import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import '@/styles/variables.css'  // 添加变量样式
import SvgIcon from '@/components/SvgIcon.vue'
import icons from '@/icons'
import './styles/theme.css'
import './views/app-square/interactions.css'
import '@cyhnkckali/vue3-color-picker/dist/style.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import DictData from '@/components/dict'

const app = createApp(App)
const pinia = createPinia()

// 注册 SVG 图标组件
app.component('svg-icon', SvgIcon)

// 注册 SVG 图标
app.use(icons)

// 注册 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(pinia)
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
  size: 'default',
  zIndex: 3000
})

// 注册插件
app.use(DictData)

app.mount('#app')

console.log('Vue app mounted successfully!')
